// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { workingHourSelfPriceApi } from '../../lib/api';
import { type WorkingHourSelfPrice } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/working-hour-self-price/';

export default (props: PageProps) => {
  const [data: WorkingHourSelfPrice, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await workingHourSelfPriceApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: WorkingHourSelfPrice) => {
    let id = payload.id;
    if (id) {
      await workingHourSelfPriceApi.update(payload);
    } else {
      let data = await workingHourSelfPriceApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: WorkingHourSelfPrice) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость нормо-часа хоз. способом'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
